import { Component } from '@angular/core'
import { RouterLink } from '@angular/router'

@Component({
  selector: 'dhp-header-logo',
  template: `
    <div class="flex flex-none items-center">
      <img
        class="h-6 max-w-xs cursor-pointer"
        [routerLink]="['/']"
        src="assets/images/logo_dh.svg"
        alt="Logo Image"
        loading="lazy"
      />
    </div>
  `,
  imports: [RouterLink],
})
export class HeaderLogoComponent {}
